<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!dpaFile || loading">
      <span class="loader"></span>
    </span>
    <div v-if="dpaFile" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        value="dpaFile"
      >
        <tab-pane title="dpaFile" id="1" :active="true">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <dpa-file-view-global :dpa-file="dpaFile" @onDpaFileUpdated="get" />
        </tab-pane>
        <tab-pane
          title="files"
          id="2"
        >
          <span slot="title">
            <i class="ni ni-folder-17"></i>
            {{ $t("DPA_PPA.TRANSACTIONS") }}
          </span>
          <div class="elite-tabs-wrapper-content">
            <show-transaction-list 
              :transactions="dpaFile.transactions"
              @refresh="get"
             />
          </div>
        </tab-pane>

        <tab-pane
          title="logs"
          id="999"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
        >
          <span slot="title">
            <i class="fa fa-file"></i>
            {{ $t("COMMON.LOGS") }}
          </span>
          <dpa-file-view-logs :dpaFile="dpaFile" />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { Tabs, TabPane } from "@/components";
import ShowTransactionList from "@/components/ElixioWallet/components/lists/ShowTransactionList.vue";
import DpaFileViewLogs from "../partials/DpaFileViewLogs.vue";
import DpaFileViewGlobal from "../partials/DpaFileViewGlobal.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    DpaFileViewLogs,
    ShowTransactionList,
    DpaFileViewGlobal,
  },

  mixins: [],

  props: {
    dpaFileId: {
      type: [String, Number],
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dpaFile: null,
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch("dpaFiles/get", this.dpaFileId);
        this.dpaFile = this.$store.getters["dpaFiles/dpaFile"];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },
};
</script>
